import translator from '@/locales';

export default [
  {
    label: translator.t('ADVERTISEMENT.MAIL_SERVICE.EMAIL_COLUMN'),
    property: 'email',
    width: 300,
  },
  {
    label: translator.t('ADVERTISEMENT.MAIL_SERVICE.STATUS_COLUMN'),
    component: () => import('./components/MailServicePageListStatusColumn'),
    property: 'status',
    width: 200,
  },
  {
    label: translator.t('ADVERTISEMENT.MAIL_SERVICE.ACTION_COLUMN'),
    component: () => import('./components/MailServicePageListActionsColumn'),
    property: 'actions',
    width: 200,
  },
];
